/* eslint-disable import/no-anonymous-default-export */
import { CompanyInfo } from './src/constants/CompanyInfo';

export default {
  title:
    'TOPTOON | manhwa | toon | comics | free | read | comic | online | cartoons | korean | Manga | webtoon',
  description:
    'TOPTOON - Enjoy our completed all-ages series for FREE - Daily webtoon, Drama, Romance, Comedy, Action, horror TOPTOON | manhwa | toon | comics | free | read | comic | online | cartoons | korean | Manga | webtoon',
  canonical: `${CompanyInfo.DOMAIN}/`,
  author: '',
  additionalLinkTags: [
    // { rel: 'manifest', href: '/favicon/manifest.json' },
    // 웹브라우저용
    {
      rel: 'icon',
      type: 'image/png',
      sizes: '16x16',
      href: '/favicon/favicon-16x16.png',
    },
    {
      rel: 'icon',
      type: 'image/png',
      sizes: '32x32',
      href: '/favicon/favicon-32x32.png',
    },

    // 안드로이드
    {
      rel: 'icon',
      type: 'image/png',
      sizes: '192x192',
      href: '/favicon/favicon-192x192.png',
    },
    {
      rel: 'android-icon',
      type: 'image/png',
      sizes: '192x192',
      href: '/favicon/favicon-192x192.png',
    },
    {
      rel: 'icon',
      type: 'image/png',
      sizes: '512x512',
      href: '/favicon/favicon-512x512.png',
    },
    {
      rel: 'android-icon',
      type: 'image/png',
      sizes: '512x512',
      href: '/favicon/favicon-512x512.png',
    },
    // ios
    {
      rel: 'apple-touch-icon',
      sizes: '152x152',
      href: '/favicon/favicon-152x152.png',
    },
    {
      rel: 'apple-touch-icon',
      sizes: '180x180',
      href: '/favicon/favicon-180x180.png',
    },
  ],
  additionalMetaTags: [
    {
      name: 'keywords',
      content:
        'TOPTOON | manwha | toon | comics | free | read | comic | oline | cartoons | korean | Manga | webtoon |',
    },
    {
      name: 'viewport',
      content:
        'width=device-width, shrink-to-fit=no, initial-scale=1.0, maximum-scale=1.0',
    },
    {
      name: 'application-name',
      content:
        'TOPTOON | manwha | toon | comics | free | read | comic | oline | cartoons | korean | Manga | webtoon |',
    },
    {
      name: 'msapplication-tooltip',
      content:
        'TOPTOON | manhwa | toon | comics | free | read | comic | online | cartoons | korean | Manga | webtoon',
    },
    {
      name: 'facebook-domain-verification',
      content: 'ke44rvkhpylrui8twrkd0xpipkl8f6',
    },
    {
      name: 'google-site-verification',
      content: '4_avR5bTFpNtk2z85LHCfs3yGl0wq6Ae00C2y_oc1pI',
    },

    {
      name: 'naver-site-verification',
      content: '18abf824ec815f1fcb9859b109752955ba8297c7',
    },
    {
      name: 'google-signin-client_id',
      content:
        '1069119357520-vaeu8t9e7sfpho46skk6pnggr6dgcdv9.apps.googleusercontent.com',
    },
    {
      name: 'theme-color',
      content: '#292929',
    },
    {
      name: 'copyright',
      content: 'TOPTOON',
    },

    {
      name: 'msapplication-TileColor',
      content: '#292929',
    },
    {
      name: 'twitter:url',
      content: `${CompanyInfo.DOMAIN}`,
    },
    {
      name: 'twitter:title',
      content: 'TOPTOON',
    },
    {
      name: 'twitter:description',
      content:
        'Thousands Of Pleasure! Explore our eccentric unlimited webtoon only available at TOPTOON!',
    },
    {
      name: 'twitter:image',
      content: `${CompanyInfo.DOMAIN}/images/seo/seo_thumb.jpg`,
    },
    {
      name: 'twitter:image:width',
      content: `600`,
    },
    {
      name: 'twitter:image:height',
      content: `600`,
    },
  ],
  openGraph: {
    type: 'website',
    url: `${CompanyInfo.DOMAIN}`,
    title:
      'TOPTOON | manhwa | toon | comics | free | read | comic | online | cartoons | korean | Manga | webtoon',
    description:
      'Enjoy our completed all-ages series for FREE - TOPTOON | manhwa | toon | comics | free | read | comic | online | cartoons | korean | Manga | webtoon',
    site_name: 'TOPTOON',
    images: [
      {
        url: `${CompanyInfo.DOMAIN}/images/seo/seo_thumb.jpg`,
        width: 470,
        height: 250,
        alt: 'TOPTOON',
      },
    ],
  },
  twitter: {
    handle: '@handle',
    site: '@site',
    cardType: 'summary_large_image',
  },
};

export const mainSEO = {
  title: 'Toptoon: Stories you never knew you needed.',
  description:
    'The official Toptoon platform. Enter a whole new way to read Web comics. Dive in thousands of stories and various genres released daily.',
};

export const originalsSEO = {
  title: 'Toptoon – Originals',
  description:
    'Exclusive & binge-worthy stories only at Toptoon. New episodes released every day.',
};

export const newSEO = {
  title: 'Toptoon – New releases',
  description: 'Check out Toptoon new releases.',
};

export const genresSEO = {
  title: 'Toptoon - Genres',
  description: 'Discover various genres from Toptoon.',
};

export const rankingSEO = {
  title: 'Toptoon – Popular titles',
  description:
    'Check out some of the most binge-worthy and interesting and fascinating titles from Toptoon.',
};

export const artworksSEO = {
  title: 'Toptoon - Characters feed',
  description:
    "Explore Toptoon's unique and charming characters and choose your favorite!",
};

export const completedSEO = {
  title: 'Toptoon - Completed',
  description:
    'Experience the utmost immersive sensation from Toptoon’s binge-worthy completed series.',
};

export const newsFeedSEO = {
  title: 'Toptoon – Announcements',
  description:
    'Check out some of our exclusive events and promotions by visiting our newsfeed.',
};

export const promoSEO = {
  title: `Toptoon – Toptoon's promotional contents and coin discounts`,
  description:
    'Visit our promo page to keep track on which series are getting discounted or even free!',
};

export const ailapSEO = {
  title: 'Toptoon – Aitoon',
  description: 'Check out Toptoon Aitoon.',
};

export const animationSEO = {
  title: 'Toptoon – Animation',
  description: 'Check out Toptoon Animation.',
};

export const OrganizationJS = {
  type: 'Organization',
  name: 'TOPTOON',
  url: `${CompanyInfo.DOMAIN}`,
  sameAs: [],
};
